import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import { DRIVER_ROLE_ID } from "@/services/consts/account";
import { OPERATION_OFFICE_TYPE } from "@/services/consts";
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccountResponse from '@/types/responses/getAccount';
import getDepartmentResponse from '@/types/responses/getDepartment';
import getAccountsType from "@/types/requests/getAccounts";
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import i18n from '@/lang/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'PassengerAutoComplete',
  props: {
    modelValue: {},
    selectedDepartment: {},
    initialItemId: {},
    driverId: {},
    managementOffice: {},
    operationOffices: {},
    errorMessages: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<getAccountResponse[]>([]);

onMounted(() => {
  const params: getAccountsType = {
    officeable_type: OPERATION_OFFICE_TYPE,
    role_id: DRIVER_ROLE_ID
  }
  if(props.operationOffices && props.operationOffices.length > 0) {
    params.type_class = OPERATION_OFFICE_TYPE,
    params.officeable_id = props.operationOffices[0].id
  }
  Api()
    .autoCompleteAccounts(params)
    .then((data) => {
      items.value = data;
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const filteredByItems = computed(() => {
  if (!props.selectedDepartment && !props.driverId) {
    return items.value
  }

  let filteredItems: getAccountResponse[] = items.value
  if (props.selectedDepartment) {
    filteredItems = items.value.filter(item => item.department_id === props.selectedDepartment?.id)
  }

  if (props.driverId) {
    filteredItems = filteredItems.filter(item => item.driver_id !== props.driverId)
  }

  return filteredItems
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: _unref(i18n).global.t('pages.common.autocomplete.passenger'),
    itemName: "name",
    items: filteredByItems.value,
    "initial-item-id": __props.initialItemId,
    "management-office": __props.managementOffice,
    "operation-offices": __props.operationOffices,
    "error-messages": __props.errorMessages
  }, null, 8, ["modelValue", "label", "items", "initial-item-id", "management-office", "operation-offices", "error-messages"]))
}
}

})